export default "__VITE_ASSET__f47b257c__"